import React from "react";
import {useTranslation} from "react-i18next";
// local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {Modal} from "components/Modal";
import {IconNotificationCircle} from "components/icons";
import {signContractStatus} from "../constants";
import {color} from "constants/color.consts";

export const SignContractProcessModal = ({status, onAccept, onClose}) => {
  const {t} = useTranslation();

  const data = {
    [signContractStatus.DRAFT]: {
      title: "SIGN_CONTRACT_SIGN_MODAL_CANCEL_TITLE",
      firstDescription: "SIGN_CONTRACT_SIGN_MODAL_CANCEL_DESCRIPTION_01",
      secondDescription: "SIGN_CONTRACT_SIGN_MODAL_CANCEL_DESCRIPTION_02",
    },
    [signContractStatus.SIGNING]: {
      title: "SIGN_CONTRACT_SIGN_MODAL_CONFIRM_TITLE",
      firstDescription: "SIGN_CONTRACT_SIGN_MODAL_CONFIRM_DESCRIPTION_01",
      secondDescription: "SIGN_CONTRACT_SIGN_MODAL_CONFIRM_DESCRIPTION_02",
    },
  };

  return (
    <Modal
      titleIcon={<IconNotificationCircle color={color.orange} addClass="mr-2" />}
      titleText={data[status].title}
      boldTitle
      noCloseButton
      noCloseOnEsc
      noCenterContent
      width="400"
      rounded
      whiteTitle
      onClose={onClose}
    >
      <div className="pb-8 pl-8 pr-8">
        <p className="">{t(data[status].firstDescription)}</p>
        <p className="">{t(data[status].secondDescription)}</p>

        <div className="df mt-8">
          <ButtonTransparent
            name="CANCEL"
            medium
            onClick={onClose}
            color="red"
            addClass="mla"
          />
          <ButtonTransparent
            name="SIGN_CONTRACT_ACTION_BUTTON_SIGN_PROCEED"
            onClick={() => onAccept(status)}
            addClass="ml-4"
            medium
            nowrap
            nonTransparent
          />
        </div>
      </div>
    </Modal>
  );
};
